import React, { useRef } from 'react'
import { SettingsRow } from "pages/NewSettings/settings-row";
import useTranslation from 'hooks/useTranslation';
import { Fields } from 'uicomponents';
import { get } from 'lodash';
import { Field } from 'formik';
import { QRCodeCanvas } from 'qrcode.react';
import { useSelector } from 'react-redux';
import { AlertOctagon } from "lucide-react";


const BasicData = ({ isSubmitting, values, setFieldValue, showClearDataModal }) => {
  const { tr } = useTranslation();
  const qrRef = useRef(null);

  const profile = useSelector((state) => state.auth.user);
  const role = useSelector(state => get(state.auth, "user.role.role"));

  const downloadQRcode = () => {
    const canvas = qrRef.current;
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = `qr_${(profile && profile.organization_id) || "org"}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div>
      <div>
        <SettingsRow
          title={tr("Лого компании")}
          description={tr("Используется как фирменный логотип компании в чеках, ссылках и брендинговых элементах")}
        >
          <div>
            <div className="d-flex mb-15 fs-14">
              <div className="fw-700">
                {tr("Лого профиля")}
              </div>
              {values.logo_id && (
                <div
                  onClick={() =>
                    setFieldValue("logo_id", null)
                  }
                  className="--danger-color text-underline cursor-pointer ml-10"
                >
                  {tr("Очистить")}
                </div>
              )}
            </div>

            <Field name="logo_id">
              {({
                field,
                form: { errors, setFieldValue, touched }
              }) => (
                <div className="d-flex justify-content-between align-items-center">
                  <Fields.UploadS2
                    type={".png"}
                    successCb={data =>
                      setFieldValue(field.name, data)
                    }
                  >
                    {({ loading }) => {
                      return (
                        <div
                          className={`form-field ${touched[field.name] &&
                            errors[field.name]
                            ? "form-field--error"
                            : ""
                            }`}
                        >
                          <div
                            className={`form-field__upload ${loading ? "--loading-dark" : ""}`}>
                            {field.value ? (
                              <div className="form-field__preview">
                                <img
                                  src={get(
                                    field.value,
                                    "thumbnails.small.src"
                                  )}
                                  alt=""
                                />
                              </div>
                            ) : (
                              <div className="form-field__upload-mask">
                                <span>
                                  {tr("Загрузить фото")}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    }}
                  </Fields.UploadS2>
                  {profile.organization_id === 1 && (
                    <div className="mr-20 cursor-pointer">
                      <QRCodeCanvas
                        ref={qrRef}
                        value="http://menu-trade.zim-zim.uz/online-menu/orders/1"
                        size={125}
                        bgColor="#fff"
                        fgColor="#000"
                        level="M"
                        includeMargin={false}
                        onClick={downloadQRcode}
                      />
                    </div>
                  )}
                </div>
              )}
            </Field>
          </div>
        </SettingsRow>
      </div>

      <SettingsRow
        title={tr("Название компании")}
        description={tr("Введите полное название компании")}
      >
        <Field
          component={Fields.InputS1}
          name="org_name_for_print"
          placeholder={tr("Введите название")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>

      <SettingsRow
        title={tr("Адрес компании")}
        description={tr("Введите текущий юридический адрес")}
      >
        <Field
          component={Fields.InputS1}
          name="address"
          placeholder={tr("Введите адрес")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>

      <SettingsRow
        title={tr("ИНН")}
        description={tr("Введите ИНН")}
      >
        <Field
          component={Fields.InputS1}
          name="tax"
          placeholder={tr("Введите")}
          isRequired={true}
          size={"small"}
        />
      </SettingsRow>

      {role === "owner" && (
        <div>
          <div className="d-panel !px-0">
            <div className="row">
              <div className="col-12">
                <button
                  type="button"
                  className="d-btn d-btn-danger !bg-[#F04438] !font-bold flex items-center justify-center w-full gap-3"
                  onClick={() => showClearDataModal(true)}
                >
                  <AlertOctagon />
                  {tr("Очистить все отчеты")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default BasicData